import { Grid, Group, Skeleton, Stack } from '@mantine/core';
import React from 'react';
import Card from '../../components/elements/Card';

const LoaderVoucher = () => {
  return (
    <Grid>
      {[...Array(6)].map((_, index) => (
        <Grid.Col span={{ base: 12, sm: 6, lg: 4 }} key={index}>
          <Card>
            <Group justify="space-between" align="flex-start">
              <Stack gap={4} flex={1}>
                {[...Array(3)].map((_, i) => (
                  <Skeleton
                    height={12}
                    key={i}
                    width={`${100 - i * 10}%`}
                    radius="xl"
                  />
                ))}
              </Stack>
              <Skeleton height={100} width={100} radius={8} />
            </Group>
          </Card>
        </Grid.Col>
      ))}
    </Grid>
  );
};

export default LoaderVoucher;
